import { render, staticRenderFns } from "./SectionComplementaryObservations.vue?vue&type=template&id=47893d9e&"
import script from "./SectionComplementaryObservations.vue?vue&type=script&lang=js&"
export * from "./SectionComplementaryObservations.vue?vue&type=script&lang=js&"
import style0 from "./SectionComplementaryObservations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports